import {getCookie} from '~/src/utilities/helpers/cookie';
import {Cookie} from '~/src/utilities/constants/cookie';

const extractLanguage = ({query, req}) => {
    if (query.lang) {
        return query.lang;
    }

    if (!process.browser && req.originalUrl === '/') {
        const langFromCookie = getCookie(Cookie.LANGUAGE, req.headers.cookie);
        if (langFromCookie) {
            return langFromCookie;
        }
    }

    return 'de';
};

/**
 * Gets the language string which is used in the legacy system
 *
 * @param language
 * @returns {string} The legacy language (de || ro (for French))
 */
const getLegacyLanguage = (language) => (language === 'fr' ? 'ro' : language);

export {extractLanguage, getLegacyLanguage};
